import type { Messages } from "../types";

export const uk = {
  "common": {
    "brand": "UN8",
    "brandTag": "Ексклюзивні християнські побачення",
    "continue": "Продовжити",
    "leave": "Залиште",
    "leaveForNow": "Залиште поки що",
    "yes": "так",
    "no": "немає",
    "goBack": "Іди назад",
    "saving": "Збереження…",
    "submitting": "Подання…",
    "pleaseWait": "Будь ласка, зачекайте…",
    "ellipsis": "…",
    "male": "Чоловік",
    "female": "Жінка",
    "phases": {
      "gate": "Ворота",
      "verify": "Підтвердити",
      "setup": "Налаштування",
      "profile": "Профіль"
    },
    "storageQuota": "На цьому телефоні немає місця для збережених відповідей. Звільніть пам’ять і повторіть спробу.",
    "storageDisabled": "Цей браузер не зберігатиме ваші відповіді. Вимкніть приватний режим або дозвольте дані сайту, а потім перезавантажте.",
    "charMeta": "{len}/{min} хв · {current}/{max}",
    "charMetaMin": "мінімум {min} символів"
  },
  "welcome": {
    "promise": "Наша мета полягає в тому, щоб ви якомога швидше видалили цю програму.",
    "sub": "UN8 допомагає серйозним неодруженим християнам знайти супутника життя — а потім піти. Перевірено. Цінності перш за все. Без нескінченного гортання.",
    "signedInAs": "Ви ввійшли як {email}",
    "liveServer": "· живий сервер",
    "deviceOnly": "· тільки цей пристрій",
    "migrateOffer": "Цей пристрій усе ще має локальний профіль. Завантажити його на спільний сервер, щоб інші телефони могли бачити вас після модерації? Нічого не буде завантажено, доки ви не виберете.",
    "uploadLocalProfile": "Завантажити мій локальний профіль",
    "keepOnDevice": "Зберігайте його лише на цьому пристрої",
    "migrateNeedGender": "Спершу виберіть Чоловік або Жінка у своєму профілі.",
    "migrateDone": "Текст профілю завантажено. Повторно завантажте ідентифікатор, відео та фотографії, щоб модерація могла їх переглянути.",
    "deleteConfirm": "Назавжди видалити ваш обліковий запис, усі повідомлення та всі медіафайли (включно з ідентифікатором і відео) із сервера?",
    "accountDeleted": "Обліковий запис видалено.",
    "begin": "Почніть",
    "continueOnboarding": "Продовжити підключення",
    "logIn": "авторизуватися",
    "logOut": "Вийти",
    "reviewConsole": "Консоль огляду",
    "matching": "Зіставлення",
    "deleteMyAccount": "Видалити мій обліковий запис"
  },
  "faith": {
    "eyebrow": "Вірні ворота",
    "title": "Тільки християни",
    "text": "UN8 — це спільнота послідовників Ісуса Христа для членів, які шукають партнера для шлюбу, який поділяє цю віру. Ці ворота неможливо пропустити.",
    "yesTitle": "Я християнка",
    "yesBody": "Я слідую за Ісусом Христом і шукаю партнера, який налаштований на шлюб і поділяє цю віру.",
    "noTitle": "Я не християнин",
    "noBody": "UN8 не те місце для мене — і це нормально.",
    "respectTitle": "З повагою",
    "respectBody": "UN8 створено для однієї спільноти, і ми краще будемо чесними, ніж витрачатимемо ваш час. Скористайтеся Залишити внизу або Назад, якщо це не ваш дім.",
    "sharedTitle": "Спільний фундамент",
    "sharedBody": "Віра тут не ярлик. Це земля, на якій ви зустрічаєтеся.",
    "hintNotChristian": "UN8 для послідовників Ісуса Христа. Торкніться «Залишити» нижче або виберіть християнський варіант, якщо це ви.",
    "hintUnset": "Натисніть «Я християнин», щоб продовжити, або «Вийти/Назад», якщо це не ваш дім."
  },
  "rules": {
    "eyebrow": "Угода спільноти",
    "title": "Як ми ставимося один до одного",
    "text": "Підтверджуйте кожне правило. Усі три обов’язкові. Порушення призводять до остаточного видалення. Фальшиві профілі заборонені назавжди.",
    "agreeContinue": "Згоден — продовжуйте",
    "respectful": {
      "title": "Будьте поважні",
      "description": "Говоріть і дійте з гідністю. Кожна людина тут створена за образом Божим."
    },
    "noSexualContent": {
      "title": "Без сексуального вмісту",
      "description": "Жодних відвертих фотографій, повідомлень чи запитів. Чистота тут не обов’язкова."
    },
    "noDominance": {
      "title": "Не домінуйте і не контролюйте",
      "description": "Жодного примусу, маніпуляції чи тиску. Любов не контролює."
    },
    "hint": "Позначте всі три обіцянки, перш ніж продовжити."
  },
  "intent": {
    "eyebrow": "",
    "title": "Що ти шукаєш?",
    "text": "",
    "marriage": {
      "label": "Супутника життя",
      "description": ""
    },
    "discernment": {
      "label": "Серйозне розпізнавання",
      "description": ""
    },
    "notCasual": {
      "label": "Нічого легковажного",
      "description": ""
    },
    "hint": "Обери одне."
  },
  "account": {
    "eyebrow": "Обліковий запис",
    "title": "Створіть свій доступ",
    "text": "Ваш маркер створює стабільний ідентифікатор користувача. Програма, перевірка, оцінки \"подобається\" та збіги - усе прив'язане до цього ідентифікатора. Електронна пошта не надсилається.",
    "recoveryTitle": "Збережіть код відновлення",
    "recoveryText": "Показано один раз. Без нього втрачену парольну фразу неможливо скинути в цьому закритому тесті.",
    "savedContinue": "Я зберіг — продовжуй",
    "handle": "Ручка",
    "handlePlaceholder": "you@example.com або короткий маркер",
    "passphrase": "Парольна фраза",
    "passphrasePlaceholder": "Мінімум 8 символів",
    "signedInTitle": "Ви ввійшли",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Стандарт довіри",
    "trustBody": "Жоден профіль не відображається, доки не буде завершено перевірку особи та модерація не схвалить вас.",
    "continueToVerification": "Перейти до перевірки",
    "hintEmail": "Введіть адресу електронної пошти, яка містить @.",
    "hintPassword": "Виберіть пароль не менше 8 символів."
  },
  "verify": {
    "intro": {
      "eyebrow": "Перевірка",
      "title": "Довіра - це ворота",
      "text": "Завантажте офіційне посвідчення особи, відео підтвердження та {min}–{max} реальних фотографій. Усе потрапляє в чергу на перегляд, перш ніж ваш профіль може з’явитися.",
      "whyTitle": "Чому ми перевіряємо",
      "whyBody": "Сомам і напівправді тут не місце. Фальшиві профілі заборонені назавжди. Медіа зберігається зі статусом pending_review до схвалення.",
      "start": "Почніть перевірку"
    },
    "steps": {
      "id": {
        "title": "Державне посвідчення особи",
        "description": "Паспорт або ідентифікаційний номер — камера або завантаження файлу."
      },
      "video": {
        "title": "Відео підтвердження",
        "description": "Короткий запис, який підтверджує вашу присутність."
      },
      "photos": {
        "title": "Реальні фотографії",
        "description": "Сім-десять чітких ваших фотографій."
      },
      "review": {
        "title": "Огляд цілісності",
        "description": "Завантаження залишаються pending_review до підтвердження персоналу."
      }
    },
    "id": {
      "eyebrow": "Крок 1 із 4",
      "title": "Державне посвідчення особи",
      "text": "Зніміть або завантажте свій паспорт або національне посвідчення особи. Нічого не публікується публічно — статус залишається pending_review до підтвердження персоналу.",
      "savedTitle": "ID збережено",
      "savedBody": "Далі йде коротке відео підтвердження вашого обличчя, а потім від 7 до 10 справжніх ваших фотографій. Продовжити розблокування, коли цей ідентифікатор відображається як збережений.",
      "hint": "Зробіть або завантажте фотографію свого державного посвідчення особи та зачекайте, доки на ньому не з’явиться повідомлення «Збережено»."
    },
    "video": {
      "eyebrow": "Крок 2 із 4",
      "title": "Відео підтвердження",
      "text": "Запишіть короткий кліп або завантажте його. Обличчям до камери. Говоріть чітко. Це доводить, що ви присутні, а не скопійована галерея.",
      "hint": "Запишіть коротке відео підтвердження, а потім зачекайте, поки з’явиться повідомлення «Збережено»."
    },
    "photos": {
      "eyebrow": "Крок 3 із 4",
      "title": "Реальні фотографії",
      "text": "Додайте {min}–10 останніх ваших фотографій. Використовуйте камеру або свою бібліотеку. Натисніть ×, щоб видалити будь-який кадр.",
      "continueToReview": "Продовжити огляд",
      "hint": "Додайте {min} до 10 своїх чітких фотографій. Продовжити розблокування, коли їх буде збережено."
    },
    "review": {
      "eyebrow": "Крок 4 із 4",
      "title": "Огляд цілісності",
      "text": "Медіа поставлено в чергу як pending_review{underUser}. Збіги та лайки використовуватимуть той самий ідентифікатор.",
      "underUser": "під користувачем {userId}",
      "governmentId": "Державне посвідчення особи",
      "confirmationVideo": "Відео підтвердження",
      "photos": "Фотографії",
      "missing": "Відсутня",
      "filesReady": "{count} файлів готово",
      "submittedTitle": "Надіслано на перевірку",
      "submittedText": "Ідентифікатор програми дорівнює ідентифікатору автентифікатора користувача, тому схвалення → пул і взаємні вподобання залишаються узгодженими.",
      "submitContinue": "Надіслати та продовжити"
    }
  },
  "setup": {
    "eyebrow": "Налаштування облікового запису",
    "title": "Скажи правду про себе",
    "text": "Ці відповіді формують відповідність і з’являються під час перегляду. М’яка брехня марнує час усіх — у тому числі й ваш.",
    "beginSetup": "Почніть налаштування",
    "pillars": {
      "faith": {
        "name": "Віра",
        "text": "Чому ви йдете за Христом."
      },
      "character": {
        "name": "характер",
        "text": "Вірність, чесність, пристрасть, відданість — оцінка 1–10."
      },
      "story": {
        "name": "Розповідь",
        "text": "Хто ти і чого шукаєш."
      },
      "life": {
        "name": "життя",
        "text": "Хобі, читання та покликання."
      }
    },
    "whyChristian": {
      "eyebrow": "Віра",
      "title": "Чому ти християнин?",
      "text": "Коротка, чесна відповідь. Не проповідь — причина ваша.",
      "label": "Ваша відповідь",
      "placeholder": "напр. Я зустрів Христа в період втрат і слідував за Ним відтоді...",
      "hint": "Напишіть принаймні {min} символів про те, чому ви йдете за Ісусом."
    }
  },
  "scales": {
    "eyebrow": "Шкала характеру",
    "title": "Оцініть себе чесно",
    "text": "Лояльність, чесність, пристрасть, відданість — кожне від 1 до 10. Завищення цифр лише пізніше не відповідає вам. Щоб продовжити, потрібно встановити всі масштаби.",
    "loyalty": {
      "label": "Рівень лояльності",
      "hint": "Будьте чесними — наскільки вірно ви стоїте на боці тих, кого любите?"
    },
    "honesty": {
      "label": "Рівень чесності",
      "hint": "Наскільки послідовно ви говорите всю правду?"
    },
    "passion": {
      "label": "Наскільки ти пристрасний?",
      "hint": "Переконливість і глибина — не продуктивність."
    },
    "commitment": {
      "label": "Рівень зобов'язань",
      "hint": "Наскільки ви готові побудувати щось довготривале?"
    },
    "hint": "Перемістіть кожен повзунок, щоб відобразилося число — жоден не може залишатися тире."
  },
  "about": {
    "eyebrow": "Про вас",
    "title": "Опишіть себе кількома реченнями",
    "text": "Хто ти, коли ніхто не виступає. Темперамент, ритм, що має значення день у день.",
    "label": "Про вас",
    "placeholder": "Тихі ранки, серйозно ставляться до сім’ї, легко сміються, віддають перевагу глибині над шумом…",
    "hint": "Напишіть про себе принаймні {min} символів."
  },
  "looking": {
    "eyebrow": "Партнер",
    "title": "що ти шукаєш",
    "text": "Основні риси характеру, які ви бажаєте отримати від потенційного партнера, а не список покупок зовнішнього вигляду.",
    "label": "Бажані риси характеру",
    "placeholder": "напр. Непохитна віра, емоційна зрілість, доброта під час стресу…",
    "hint": "Напишіть принаймні {min} символів про партнера, на якого ви сподіваєтесь."
  },
  "loveReady": {
    "eyebrow": "Поріг",
    "title": "Чи готові ви зустріти кохання свого життя?",
    "text": "UN8 існує, тому серйозні неодружені знаходять партнера — потім видаляють додаток. Only “Yes” unlocks continue.",
    "yesTitle": "Так — я готовий",
    "yesBody": "Я тут, щоб зустріти свою людину з ясністю та сміливістю.",
    "noTitle": "ще ні",
    "noBody": "Якщо ви лише переглядаєте, ця спільнота не підходить.",
    "comeBackTitle": "Поверніться, коли будете готові",
    "comeBackBody": "UN8 для людей, готових зустрітися, а не для того, щоб збирати варіанти. Скористайтеся «Залишити» нижче, якщо ви хочете поки що зупинитися. Ваші відповіді зберігаються на цьому телефоні.",
    "hintNo": "Продовжується лише «так». Якщо ви не готові, торкніться поки що залишити — ваші відповіді залишаться на цьому телефоні.",
    "hintUnset": "Натисніть «Так», якщо ви готові зустрітися з кимось для одруження."
  },
  "lifestyle": {
    "eyebrow": "Спосіб життя",
    "title": "Як ти живеш день у день",
    "text": "Спорт, хобі, читання і професія — практичні сигнали для справжньої сумісності.",
    "hobbies": "Актуальні види спорту чи хобі",
    "hobbiesPlaceholder": "Те, що ви робите активно, а не те, що ви робили колись.",
    "reading": "Ви читаєте?",
    "readingHint": "1 = майже ніколи · 10 = щоденне, глибоке читання",
    "profession": "Професія / галузь",
    "professionPlaceholder": "напр. Догляд · Програмне забезпечення · Освіта · Професії",
    "hintHobbies": "Назвіть хоча б один вид спорту чи хобі, яким ви насправді займаєтесь.",
    "hintReading": "Слайд «Чи читаєш ти?» тому число від 1 до 10 показує.",
    "hintProfession": "Введіть роботу, яку ви виконуєте, навіть коротке слово."
  },
  "faithDepth": {
    "eyebrow": "Відповідність · Віра",
    "title": "Наскільки центральною є ваша віра?",
    "text": "Служити Богу — наскільки це важливо у вашому житті? Відповідайте чесно. Зіставлення використовує це для глибини, а не продуктивності.",
    "serving": "Служити Богу — важливо",
    "servingHint": "10% … 100%. Слайд з кроком 10.",
    "keepsCommandments": "Чи дотримуєшся ти заповідей?",
    "grewUpInChurch": "Ви виросли в церкві?",
    "churchAttendance": "Відвідування церкви",
    "frequent": {
      "label": "часті",
      "hint": "Регулярне зібрання з тілом Христовим."
    },
    "seldom": {
      "label": "Рідко",
      "hint": "Час від часу не в тижневому ритмі."
    },
    "never": {
      "label": "Ніколи",
      "hint": "Зараз не відвідую."
    },
    "spreadsGospel": "Ви поширюєте євангелію?",
    "hasIdols": "У вас є кумири?",
    "hintServing": "Покажіть, наскільки важливим у вашому житті є служіння Богу.",
    "hintCommandments": "Дайте відповідь, чи виконуєте ви заповіді — так чи ні.",
    "hintGrewUp": "Дайте відповідь, чи виросли ви в церкві — так чи ні.",
    "hintAttendance": "Виберіть, як часто ви відвідуєте церкву.",
    "hintGospel": "Дайте відповідь, чи поділяєте ви євангелію — так чи ні.",
    "hintIdols": "Дайте відповідь, чи є у вас кумири — так чи ні."
  },
  "character": {
    "eyebrow": "Відповідність · Характер",
    "title": "Хто ти вдома",
    "text": "Характер для залицяння — миролюбність, манірність, чесність. Завищені відповіді лише згодом не збігаються.",
    "peacemaker": "Ви миротворець?",
    "homebuilder": "Ви домобудівник?",
    "humorous": "Ви гуморуєте?",
    "caring": "Турботливий і ласкавий?",
    "peacefulHome": "Ви хочете мирного дому — без бійки?",
    "manners": "Хороші манери?",
    "honestyRating": "Рейтинг чесності в цій анкеті",
    "honestyHint": "1–10 — наскільки чесно ви відповідаєте?",
    "hintPeacemaker": "Дайте відповіді на кожне питання «Так» або «Ні», починаючи з «Миротворець».",
    "hintHomebuilder": "Дайте відповідь, чи є ви домобудівником.",
    "hintHumorous": "Дайте відповідь, чи відчуваєте ви гумор.",
    "hintCaring": "Дайте відповідь, чи турботливі ви і ніжні.",
    "hintPeaceful": "Дайте відповідь, чи хочете ви спокійного дому.",
    "hintManners": "Дайте відповідь, чи маєте ви хороші манери.",
    "hintHonesty": "Змістіть свій рейтинг чесності з 1 до 10."
  },
  "history": {
    "eyebrow": "Зіставлення · Історія",
    "title": "Минуле і готовність",
    "text": "Речовини, дитинство, шрами та чи готові ви до тривалих стосунків. Правда тут захищає вас обох.",
    "marijuana": "Ви вживали марихуану?",
    "lsd": "Ви вживали ЛСД?",
    "otherDrugs": "Ви вживали інші наркотики?",
    "addicted": "Ви були залежними?",
    "childhood": "Стабільне, любляче дитинство?",
    "scars": "Є шрами / пошкодження?",
    "lasting": "Готові до тривалих стосунків?",
    "hintStart": "Дайте відповіді на кожне «Так» чи «Ні» на цій сторінці, починаючи згори.",
    "hintLsd": "Дайте відповідь на запитання про ЛСД — Так чи Ні.",
    "hintOtherDrugs": "Дайте відповідь, чи вживали ви інші наркотики.",
    "hintAddicted": "Дайте відповідь, чи були у вас залежні.",
    "hintChildhood": "Дайте відповідь, чи було ваше дитинство стабільним і повним любові.",
    "hintScars": "Дайте відповідь, чи є у вас шрами.",
    "hintLasting": "Дайте відповідь, чи готові ви до тривалих стосунків."
  },
  "appearance": {
    "eyebrow": "Відповідність · Зовнішній вигляд",
    "title": "Татуювання",
    "text": "Ваші татуювання та чи прийнятні для вас татуювання на партнері.",
    "hasTattoos": "У вас є татуювання?",
    "acceptsPartner": "Прийняти татуювання на партнера?",
    "hintHas": "Скажіть, чи є у вас татуювання — Так чи Ні.",
    "hintAccepts": "Скажіть, чи прийнятні для вас татуювання на партнері."
  },
  "home": {
    "eyebrow": "Відповідність · Дім і земля",
    "title": "Земля, навички, самоокупність",
    "text": "Трави, вирощування їжі, фруктовий ліс, підготовка, громадське землеробство, збереження, виживання — і будь-які спеціальні навички.",
    "herbKnowledge": "Знання трав?",
    "plantOwn": "Ви самі садите фрукти та овочі?",
    "fruitForest": "Вас цікавить фруктовий ліс?",
    "prepping": "Готуйтеся до лиха?",
    "communityFarming": "Громадське господарство / незалежне життя?",
    "canning": "Консервування та консервування?",
    "survival": "Навички виживання?",
    "specialSkills": "Спеціальні навички (за бажанням)",
    "specialPlaceholder": "Усе інше, що ви принесете в домівку чи на землю…",
    "hintStart": "Відповідайте на кожне «Так» чи «Ні» щодо землі та навичок, починаючи з верхньої частини.",
    "hintPlant": "Дайте відповідь, чи садите ви власні фрукти та овочі.",
    "hintFruitForest": "Дайте відповідь, чи цікавить вас фруктовий ліс.",
    "hintPrepping": "Дайте відповідь, чи готуєтеся ви до лиха.",
    "hintCommunity": "Дайте відповідь, чи цікавить вас громадське господарство.",
    "hintCanning": "Відповідь, чи можна і консервувати їжу.",
    "hintSurvival": "Дайте відповідь, чи володієте ви навичками виживання."
  },
  "family": {
    "eyebrow": "Відповідність · Сім'я",
    "title": "Діти, глибина віри, речовини",
    "text": "Що вам потрібно від партнера щодо інтенсивності віри, дітей і вживання психоактивних речовин у минулому.",
    "children": "діти",
    "wants": {
      "label": "Хоче дітей",
      "hint": "Створення сім’ї є частиною бачення."
    },
    "doesNotWant": {
      "label": "Не хоче дітей",
      "hint": "Дітям чітко ні."
    },
    "open": {
      "label": "ВІДЧИНЕНО",
      "hint": "Розбірливий — не заблокований ні в якому разі."
    },
    "hasLivingWith": {
      "label": "Має дітей — проживає з ними",
      "hint": "Діти вже є частиною повсякденного життя."
    },
    "requiredFaith": "Мінімальний рівень віри в партнера",
    "requiredFaithHint": "10% … 100%. Жорсткі ворота, коли обидві сторони відповіли.",
    "acceptsSubstances": "Прийняти минуле вживання психоактивних речовин партнером?",
    "hintChildren": "Виберіть одну картку про дітей.",
    "hintFaith": "Зменште мінімальний рівень віри в партнера, на який ви сподіваєтесь.",
    "hintSubstances": "Скажіть, чи прийнятно минуле вживання психоактивних речовин партнером."
  },
  "ancestry": {
    "eyebrow": "Відповідність · Фон",
    "title": "Налаштування фону",
    "text": "Поділіться своїм минулим і тим, до чого ви відкриті в партнері. Це лише формує рейтинг — воно ніколи не приховує когось із колоди.",
    "yourBackground": "Ваш фон (виберіть усе, що підходить)",
    "openToPartner": "Відкриті в партнері",
    "codeDesc": "Код: {code}",
    "anyDesc": "Найбільша перевага щодо широти — рекомендується, якщо ви не впевнені.",
    "preferenceOnly": "Лише перевага — не ворота.",
    "hintOwn": "Позначте принаймні одну історію, яка описує вас. Це лише сприяє рейтингу — воно ніколи нікого не приховує.",
    "hintAccepted": "Позначте галочкою те, до чого ви відкриті в партнері, або «Відкрито — без переваг»."
  },
  "interests": {
    "eyebrow": "Відповідність · Інтереси",
    "title": "Те, що вам подобається",
    "text": "Виберіть хоча б одну. Перекриття допомагає ранжируванню; мовчання ніколи не карається.",
    "hint": "Позначте хоча б один інтерес."
  },
  "reflection": {
    "eyebrow": "Встановлення відповідності · Рефлексія",
    "title": "Своїми словами",
    "text": "Ці чотири відповіді показані повністю і не оцінюються. Пишіть, що правда.",
    "describeYourself": "Опишіть себе",
    "lifePurpose": "Мета життя",
    "fifteenYear": "Ти і кохання всього твого життя через 15 років",
    "weaknesses": "Слабкі сторони",
    "hintDescribe": "Опишіть себе принаймні {min} символами.",
    "hintPurpose": "Напишіть мету свого життя принаймні {min} символами.",
    "hintVision": "Напишіть 15-річне бачення принаймні {min} символами.",
    "hintWeaknesses": "Назвіть недолік принаймні {min} символами."
  },
  "profile": {
    "eyebrow": "Профіль",
    "title": "Кілька необхідних речей",
    "text": "Будьте простими. Стать тут двійкова — чоловіча чи жіноча — для чіткого збігу.",
    "firstName": "ім'я",
    "firstNamePlaceholder": "Як ви хочете, щоб вас знали",
    "age": "Вік",
    "agePlaceholder": "18+",
    "city": "місто",
    "cityPlaceholder": "Де ви базуєтесь",
    "sex": "секс",
    "maleBody": "Я чоловік.",
    "femaleBody": "Я жінка.",
    "hintName": "Введіть своє ім'я (мінімум дві літери).",
    "hintAge": "Вік повинен бути 18 або старше.",
    "hintCity": "Введіть місто, де ви живете.",
    "hintGender": "Виберіть чоловічий або жіночий, щоб відповідність могла працювати."
  },
  "ready": {
    "title": "Ви можете входити.",
    "textNamed": "{name}, ваша перевірка та налаштування записані. Медіа pending_review. Ласкаво просимо до UN8 — знайдіть свою особу, а потім видаліть додаток.",
    "text": "Ваша перевірка та налаштування записуються. Медіа pending_review. Ласкаво просимо до UN8 — знайдіть свою особу, а потім видаліть додаток.",
    "summaryAria": "Підсумок налаштування",
    "christianRules": "Затвердження християнських правил",
    "mediaLine": "ID · відео · {photoCount} фото · черга {pending}",
    "scalesLine": "Ваги L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "секс —",
    "professionFallback": "професія",
    "userLine": "Користувач {userId}",
    "enterMatching": "Введіть відповідність",
    "needGender": "Поверніться до профілю та виберіть «Чоловік» або «Жінка», а потім повторіть спробу."
  },
  "match": {
    "brandTag": "Зіставлення",
    "navOnboarding": "Онбордінг",
    "navReview": "огляд",
    "navMatching": "Зіставлення",
    "logOut": "Вийти",
    "enterTitle": "Введіть відповідність",
    "enterText": "Увійдіть за допомогою тієї самої електронної пошти, що й у системі реєстрації. Програма, пул, лайки та збіги використовують ваш стабільний ідентифікатор користувача.",
    "email": "Електронна пошта",
    "emailPlaceholder": "you@example.com",
    "password": "Пароль",
    "passwordPlaceholder": "Ваш пароль",
    "logIn": "авторизуватися",
    "guestOr": "Або спробуйте гостьовий сеанс (стабільний ідентифікатор для браузера · лише демо)",
    "guestMan": "Гість як людина",
    "guestWoman": "Гість як жінка",
    "goOnboarding": "Перейти до адаптації →",
    "guestSession": "Гостьова сесія · демонстраційний пул",
    "packTitle": "Твої четверо",
    "packSkip": "Натисни, щоб продовжити",
    "newSelection": "Новий вибір",
    "backToFour": "← Назад до своїх чотирьох",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "людина",
    "woman": "жінка",
    "navSelection": "Вибір",
    "navMessages": "Повідомлення",
    "navProfile": "Профіль",
    "tabToday": "Вибір",
    "tabMatches": "Збіги ({count})",
    "yourMatches": "Ваші збіги",
    "matchesSub": "Постійний взаємний інтерес · {count} вихідний {likesWord}",
    "like": "як",
    "likes": "подобається",
    "emptyMatches": "Ще немає взаємної зацікавленості. Продовжуй розрізняти вибір цього тижня.",
    "valuesScore": "Значення {score}",
    "chatOpen": "· Чат відкрито",
    "tapToChat": "· Натисніть, щоб спілкуватися",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Значення {score}",
    "noProfileYet": "Ще немає профілю",
    "noProfileText": "Завершіть адаптацію або торкніть «Розрахунок» угорі, а потім «Почати». Підбір гостей на екрані входу, якщо ви хочете лише подивитися.",
    "matchingPaused": "Зіставлення призупинено",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Поки що нема кому показати",
    "todaysSetDone": "Це вибір цього тижня",
    "weeklyTitle": "Твої 4 на цей тиждень",
    "weeklyTitleCount": "Твої {count} на цей тиждень",
    "weeklyCountdown": "Наступний вибір через {days} дн.",
    "weeklyCountdownOne": "Наступний вибір через 1 день",
    "weeklyCountdownSoon": "Наступний вибір незабаром",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Це вибір цього тижня",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "У списку цього тижня ще нікого немає. Пул наповнюється — відкрий Вибір за мить або повернись, коли схвалимо більше людей.",
    "emptyDone": "Ти переглянув вибір цього тижня. Повернись до наступного відкриття або скинь колоду.",
    "likesMayNotStick": "Лайки можуть не прилипнути.",
    "poolMeta": "Пул: {pool} · Матчів: {matches} · Подобається: {liked}",
    "demoPool": "демо",
    "livePool": "{source} ({count})",
    "resetDeck": "Скинути колоду",
    "backOnboarding": "Повернутися до адаптації",
    "feedEyebrowDemo": "Тижневий вибір · Демо",
    "feedEyebrowLive": "Тижневий вибір · Пул ({source}, {count})",
    "feedTitle": "Розрізняйте з обережністю",
    "left": "залишилося {count}",
    "pass": "Пас",
    "interested": "зацікавлений",
    "swipeHint": "Гортайте або використовуйте кнопки. Матч відкривається лише тоді, коли інтерес обопільний і зберігається.",
    "celebrationEyebrow": "Взаємний інтерес",
    "celebrationTitle": "Ви збіглися",
    "celebrationText": "{self} і {other} виявили інтерес. Вирівнювання значень: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Чат для цього матчу розблоковано. Зберігайте це з повагою — заповіт над зручністю.",
    "openChat": "Відкрити чат",
    "keepDiscerning": "Продовжуйте розбірливість",
    "cardSeeking": "шукає",
    "cardHobbies": "хобі",
    "affinity": "Спорідненість",
    "valuesScoreLabel": "Оцінка цінностей",
    "scoreStrong": "Міцне вирівнювання",
    "scoreSolid": "Суцільне вирівнювання",
    "scoreModerate": "Помірне вирівнювання",
    "scoreDifferent": "Різні ритми",
    "characterAxisFoot": "Вісь символів включає чотири стовпи",
    "youThem": "Ви {self} · Вони {other}",
    "stampInterest": "інтерес",
    "stampPass": "Пас",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Ваші оцінки цінностей розташовані близько один до одного ({score} зі 100).",
    "explainLegacyFuller": "Більш повне «чому» з’являється після того, як ви обидва закінчите відповідати відповідним запитанням.",
    "explainFaith": "Ваша інтенсивність віри близька — ви з такою ж серйозністю ставитеся до Ісуса.",
    "explainCharacter": "Як ви ставитеся до людей вдома, вибудовується — мир, манери, турбота.",
    "explainPurpose": "Ви так само оцінили свою чесність, що є ознакою спільної серйозності.",
    "explainHome": "Вас цікавить земля, вирощування їжі або самодостатній будинок.",
    "explainAncestry": "Ви обоє віддаєте перевагу схожому сімейному минулому. Це вподобання, а не фільтр — за ним ніхто не прихований.",
    "explainTemperament": "Ваші інтереси і темперамент збігаються.",
    "explainFallback": "Можливий збіг відповідей, які ви обидва заповнили.",
    "explainOverall": "Загальна спорідненість {score} зі 100.",
    "affinityAxes": {
      "faith": "Інтенсивність віри",
      "character": "Характер і поведінка",
      "purpose": "Вирівнювання цілей життя",
      "home": "Дім і самодостатність",
      "ancestry": "Культурна та фонова спорідненість",
      "temperament": "Темперамент підходить"
    },
    "scaleAxes": {
      "loyalty": "Лояльність",
      "honesty": "Чесність",
      "passion": "пристрасть",
      "commitment": "Зобов'язання"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Чат",
    "unavailableTitle": "Чат недоступний",
    "unavailableText": "Цей збіг відсутній або не належить до вашого сеансу.",
    "backToMatches": "Назад до матчів",
    "backMatches": "← Сірники",
    "valuesSubscriber": "Значення {score} · Підписник",
    "valuesTrial": "Значення {score} · Випробування",
    "valuesKept": "Значення {score} · Збіг збережено",
    "empty": "Привітайтеся з увагою. На спільній серверній частині повідомлення синхронізуються на обох телефонах після взаємного збігу.",
    "placeholder": "Повідомлення {name}…",
    "ariaMessage": "повідомлення",
    "send": "Надіслати"
  },
  "billing": {
    "paywallCopy": "Після безкоштовного пробного періоду залиште всіх, з ким ви вже зустрічалися, і продовжуйте спілкуватися. Щоб побачити нових людей, підпишіться.",
    "signInToMatch": "Увійдіть, щоб використовувати відповідність.",
    "signInFirst": "Спочатку увійдіть.",
    "subscriberUntil": "Підписка · до {date}",
    "renewal": "поновлення",
    "freeTrial": "Безкоштовна пробна версія · {days} днів (закінчується {date})",
    "soon": "скоро",
    "trialEnded": "Випробування завершено · матчі та чат залишаються відкритими",
    "subscribe": "Підписатися · ${price}/міс",
    "subscribeEarly": "Підпишіться раніше · ${price}/міс",
    "activeNote": "Підписка активна — ви знову можете бачити нових людей.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Збережіть код відновлення",
    "recoveryText": "Запишіть це зараз. Показується один раз. Якщо ви втратите свою парольну фразу, цей код є єдиним способом скинути її під час закритого тесту.",
    "savedContinue": "Я зберіг — продовжуй",
    "welcomeBack": "Ласкаво просимо назад",
    "createAccount": "Створіть свій акаунт",
    "intro": "Ідентифікатор і парольна фраза. Електронна пошта чи SMS не надсилаються. Ваш ідентифікатор залишається стабільним під час реєстрації, перевірки та зіставлення.",
    "tabLogin": "авторизуватися",
    "tabRegister": "зареєструватися",
    "handle": "Ручка",
    "handlePlaceholder": "you@example.com або короткий маркер",
    "passphrase": "Парольна фраза",
    "passphrasePlaceholder": "Мінімум 8 символів",
    "submitLogin": "авторизуватися",
    "submitRegister": "Створити акаунт",
    "backWelcome": "Назад до вітання"
  },
  "options": {
    "origin": {
      "african": "африканський",
      "european": "європейський",
      "asian": "Азіатський",
      "latino": "Латиноамериканець / іспанець",
      "middleEastern": "близькосхідний",
      "indigenous": "корінне населення",
      "mixed": "змішаний",
      "other": "інше",
      "dutch": "голландська",
      "german": "Німецький",
      "any": "Відкрито — без переваг"
    },
    "interest": {
      "prayer": "Молитва",
      "worship": "Богослужіння",
      "reading": "Читання",
      "hiking": "Піші прогулянки",
      "music": "музика",
      "cooking": "Кулінарія",
      "farming": "Сільське господарство / садівництво",
      "sports": "спорт",
      "missions": "Місії",
      "family": "Сімейне життя",
      "crafts": "Ремесла",
      "outdoors": "На відкритому повітрі"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "так",
      "no": "немає"
    },
    "id": {
      "titleEmpty": "Державне посвідчення особи",
      "titleReady": "ID готовий",
      "hintEmpty": "Паспорт або національне посвідчення особи. Зробіть живу фотографію або виберіть зображення/PDF. Видно всі чотири кути.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· збережені",
      "previewAlt": "Попередній перегляд державного ідентифікатора",
      "pdfAria": "Вибрано документ PDF",
      "takePhoto": "Зробіть фото",
      "retake": "Перезняти",
      "chooseFile": "Виберіть файл",
      "replaceFile": "Замінити файл",
      "remove": "видалити",
      "uploading": "Завантаження…",
      "cameraTitle": "Сфотографуйте своє посвідчення особи",
      "signIn": "Увійдіть перед завантаженням ідентифікатора.",
      "uploadFailed": "Помилка завантаження. Спробуйте знову.",
      "badFile": "Не вдалося використати цей файл."
    },
    "video": {
      "titleEmpty": "Відео підтвердження",
      "titleLive": "Камера в прямому ефірі",
      "titleReady": "Готове відео",
      "hintEmpty": "Скажіть своє ім’я та чесно скажіть, що ви приєднуєтеся до UN8. 5–15 секунд.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "запис",
      "cameraUpload": "Завантаження камери",
      "chooseFile": "Виберіть файл",
      "startRecording": "Почніть запис",
      "cancel": "Скасувати",
      "stopSave": "Зупинити та зберегти",
      "recordAgain": "Запис знову",
      "replaceFile": "Замінити файл",
      "remove": "видалити",
      "unsupported": "Живий запис тут недоступний. Використовуйте завантаження з камери або виберіть файл.",
      "permissionDenied": "Відмовлено в дозволі на камеру. Ви все ще можете завантажити короткий відеофайл.",
      "signIn": "Увійдіть перед завантаженням відео.",
      "uploadFailed": "Помилка завантаження. Спробуйте знову.",
      "saveFailed": "Не вдалося зберегти запис.",
      "badVideo": "Не вдалося використати це відео."
    },
    "photos": {
      "count": "{count} / {max} фото",
      "minimumMet": "Мінімум виконано",
      "moreRequired": "Потрібно ще {n}",
      "listAria": "Підтвердження фото",
      "photoAlt": "Фото {n}",
      "removeAria": "Видалити фото {n}",
      "camera": "Камера",
      "takePhoto": "Зробіть фото",
      "chooseFiles": "Виберіть файли",
      "uploading": "Завантаження…",
      "hint": "Зробити фото відкриває камеру в прямому ефірі. Виберіть файли лише для вибору з галереї. Чіткі знімки обличчя — жодних фільтрів, які приховують особу. Макс. {max}.",
      "cameraTitle": "Сфотографуй себе",
      "signIn": "Увійдіть перед завантаженням фотографій.",
      "someFailed": "Деякі фотографії не вдалося завантажити. Повторіть невдалі.",
      "addFailed": "Не вдалося додати фотографії."
    },
    "liveStill": {
      "titleDefault": "Камера",
      "close": "Закрити",
      "capture": "захоплення",
      "cancel": "Скасувати",
      "hint": "Тримайся стійко. The live camera stays open until you capture.",
      "unavailable": "Camera is not available in this browser. Натомість використовуйте Вибрати файл.",
      "permissionDenied": "Camera permission denied or unavailable. Натомість використовуйте Вибрати файл.",
      "frameFailed": "Не вдалося зняти цей кадр.",
      "saveFailed": "Не вдалося зберегти фото."
    },
    "uploadStatus": {
      "uploading": "завантаження…",
      "failed": "не вдалося завантажити",
      "savedLocally": "збережено локально",
      "uploaded": "завантажено",
      "stored": "зберігається",
      "awaitingUpload": "Очікується завантаження",
      "localFallbackNote": "{error} Файл збережено на цьому пристрої; повторіть спробу, коли кінцева точка знака піднята."
    }
  },
  "language": {
    "label": "Мова",
    "choose": "Виберіть мову"
  },
  "shell": {
    "back": "Назад",
    "goBackAria": "Іди назад"
  }
} as Messages;
